import { ContentContext, DatelineContext, LocaleContext } from 'Components/hooks/context';

import Credits from 'Components/common/Credits';
import Footer from 'Components/common/Footer';
import Head from 'Components/common/Head';
import Header from 'Components/common/Header';
import LinkBox from 'Components/common/LinkBox';
import Page from './Page';
import ShareButtons from 'Components/common/ShareButtons';

const App = (props) => {
  return (
    <>
      <LocaleContext.Provider value={props.locale}>
        <DatelineContext.Provider value={props.globalStatistics.lastUpdated}>
          <ContentContext.Provider value={props.content}>
            <Head />
            <Header global />
            <Page {...props} />
            <LinkBox globalStatistics={props.globalStatistics} />
            <Credits />
            <Footer />
            <ShareButtons />
          </ContentContext.Provider>
        </DatelineContext.Provider>
      </LocaleContext.Provider>
    </>
  );
};

export default App;
